<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/112/title-bg.png" alt="" />
            <div class="technological-process">
                <!-- <div class="rhtj mar-t2">
                    <img class="top" src="./../assets/imgs/26/title-1.png" alt="" />
                    <div class="content">
                        《成都市武侯区“诸葛工匠”评选管理办法》——成武委组通〔2019〕3号
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/26/title-2.png" alt="" />
                    <div class="content">
                        具有工艺专长、掌握高超技能，技艺精湛、精益求精，严谨细致、专业敬业，长期坚守在生产服务一线岗位，并在本领域、行业内具有较高公认度和示范引领作用的产业工人代表以及行业领军人物。
                    </div>
                </div> -->
                <div class="fund">
                    <img class="top" src="./../assets/imgs/112/title-1.png" alt="" />
                    <div class="content">
                        <div class="text">
                            （一）“简阳工匠”评选对象面向本市所有职工（含农民工），重点聚焦现先进制造业、新兴服务业中的一线工人，不受年龄、学历、资历和身份等限制。
                        </div>
                        <div class="text">
                            （二）“简阳工匠”的评选条件包括基础条件和技能条件。在符合基础条件的情况下，技能条件具备一个即可申报“简阳工匠”。对在简阳经济社会建设中做出重大贡献的技能人才，可适当放宽参评条件。<br/> <span style="fontWeight:bold">基础条件：</span><br/> 拥护中国共产党领导，自觉遵守宪法和法律，热爱祖国，爱岗敬业，善于创新，甘于奉献，具备优良的职业道德和职业操守。<br/> <span style="fontWeight:bold">技能条件：</span> <br/>1.获得国家、省、成都市、简阳市技能技术荣誉称号；<br/> 2.享受国务院政府津贴或成都市政府特殊津贴；<br/> 3.世界技能大赛获奖选手；获得全国技能比赛前 20名、省级技能比赛前 6 名、成都市一类比赛前 6 名、简阳市二类比赛第 1 名；<br/> 4.成都市级以上技能大师工作室、首席技师工作室，简阳市级以上劳模（职工）创新工作室领军人物；<br/> 5.在技术创新、攻克技术难关等方面做出突出贡献，并总结出独特的操作工艺和操作方法，产生重大经济效益或社会效益；具有丰富的实践经验和一定的理论知识，拥有高超绝技，在本单位、本行业、本领域处于领先水平，具有较高的知名度和社会影响力；<br/> 6.具有一定的绝技绝活，在挖掘和传承制造工艺上做出重大贡献。擅长带领团队攻坚克难，在职工队伍中具有较高威信；在带徒传技、技能推广等方面发挥示范作用，乐于向职工传授技艺、传播理念、传授经验，引领带动职工队伍共同成长。
                        </div>
                        <div class="text">
                            （三）获得国家、省、成都市级科学技术进步奖或者发明专利并得到推广应用。
                        </div>
                        <div class="text">
                            （四）注重节能减排，善于研发新材料、新产品、新工艺、新设备，为企业不断增强市场竞争力和推动企业转型升级作出重大贡献。
                        </div>
                        <div class="text">
                            （五）获得“大国工匠”、“四川工匠”、“天府工匠”、“成都工匠”的本市产业工人申报“简阳工匠”，直接认定。
                        </div>
                        <div class="text">
                            （六）处于违法犯罪处罚期和违纪影响期的个人，不得参加“简阳工匠”评选。
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img class="top" src="./../assets/imgs/112/title-2.png" alt="" />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">申报推荐</div>
                                </div>
                                <div class="line-content">
                                   “简阳工匠”申报推荐方式有：个人申报、企业推荐、行业协会推荐、基层工会推荐。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">资格审核</div>
                                </div>
                                <div class="line-content">
                                    1.按照“谁推荐、谁初审”的原则，由推荐单位对照“简阳工匠”的评选条件进行初审，个人申报的由工作所在基层工会进行初审；
                                    <br/>2.市总工会对所有申报人员进行资格审核。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">专家评审</div>
                                </div>
                                <div class="line-content">
                                    1.市总工会负责组建“简阳工匠”专家评审委员会；<br/>
2.专家评审委员会实行“一年一组建”、“ 一评一授权”；<br/>
3.专家评审委员会按照评选条件对申报对象的技能水平、业绩和贡献等进行综合评价，确定“简阳工匠”候选人建议名单。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">社会公示</div>
                                </div>
                                <div class="line-content">
                                    1.通过网络、报纸等媒体对“简阳工匠”候选人名单进行社会公示，接受社会监督，公示时间不少于 5 个工作日；<br/>
2.公示期内，对公示人选有异议，经调查核实成立的，取消评选资格。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">审批命名</div>
                                </div>
                                <div class="line-content">
                                    公示无异议后，报请市人才工作领导小组审批，由市委、市政府命名。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fund">
                    <img class="top" src="./../assets/imgs/112/title-3.png" alt="" />
                    <div class="content">
                        <div class="text">
                           （一）“简阳工匠”由市总工会统一管理。
                        </div>
                        <div class="text">
                           （二）对工作调动离开本市的，保留工匠称号，不再享受工匠相关待遇
                        </div>
                        <div class="text">
                           （三）有下列情形之一者，取消“简阳工匠”荣誉称号，注销证书。<br/>
1.违法受到刑事处罚的；<br/>
2.违纪受到撤销党内职务及以上党纪处分的或受到降级及以上政纪处分的；<br/>
3.道德品质败坏，在群众中和社会上造成恶劣影响的；<br/>
4.其他不宜保留称号的。
                        </div>
                        <div class="text">
                           （四）对违反评选规定和评选程序、弄虚作假的，取消“简阳工匠”荣誉称号，根据有关规定追回奖励资金，录入征信系统。涉嫌犯罪的，移交司法机关依法处理。
                        </div>
                    </div>
                </div>
                <!-- <div class="contact">
                                <img
                                    class="top"
                                    src="./../assets/imgs/26/contact5.png"
                                    alt=""
                                />
                                <div class="content">
                                    <div>
                                        政策咨询电话：
                                        <a href="tel:028-85511053">028-85511053</a>
                                    </div>
                                    <div>咨询单位：成都市武侯区总工会</div>
                                </div>
                            </div> -->
                <div class="contact">
                    <img class="top" src="./../assets/imgs/112/title-4.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-27755792">028-27755792</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            简阳市总工会
                        </div>
                        <!-- <div>
                                        政策咨询电话：
                                        <a href="tel:028-86259119">028-86259119</a>
                                    </div>
                                    <div>责任单位：中共成都市青羊区委组织部人才科</div> -->
                    </div>
                </div>
                <!-- <div class="codes">
                    <img class="code" src="../assets/imgs/26/code.png" />
                    <img class="text" src="../assets/imgs/26/text.png" />
                </div> -->
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 4.44rem;
    }

    .technological-process {
        transform: translateY(-1.2rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;
            }
        }


        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .fund {
            position: relative;
            margin-top: 0.8rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .text {
                    background-color: #fff;
                    box-sizing: border-box;
                    padding: 0.42rem 0.25rem;
                    font-size: 0.26rem;
                    border-radius: 0.26rem;
                    color: #4e4e4e;
                    margin-bottom: 0.2rem;
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
